import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, User, Home, Shield, Clock } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';

const RequestSummary = () => {
  const navigate = useNavigate();
  const { currentRequest } = useAuthStore();

  const steps = [
    { icon: User, title: 'Identity Document', description: 'Upload passport or driving licence' },
    { icon: Shield, title: 'Selfie Verification', description: 'Quick photo to verify it\'s you' },
    { icon: Home, title: 'Address Proof', description: 'Upload a recent utility bill or bank statement' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 p-4 safe-area-top">
        <h1 className="text-lg font-semibold">What you'll need</h1>
      </div>

      {/* Content */}
      <div className="flex-1 p-6">
        <div className="max-w-md mx-auto">
          <div className="flex items-center justify-center mb-6">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
              <Clock className="w-10 h-10 text-blue-600" />
            </div>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 text-center mb-2">
            About 3-5 minutes
          </h2>
          <p className="text-gray-600 text-center mb-8">
            Have these items ready before you start
          </p>

          <div className="space-y-4 mb-8">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div key={index} className="bg-white rounded-xl p-4 shadow-sm flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">{step.title}</h3>
                    <p className="text-sm text-gray-600">{step.description}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="bg-amber-50 rounded-xl p-4 mb-8">
            <p className="text-sm text-amber-800">
              <span className="font-medium">Tip:</span> Make sure you're in a well-lit area 
              and have your documents nearby.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="p-6 bg-white border-t border-gray-200 safe-area-bottom">
        <button
          onClick={() => navigate('/id-capture')}
          className="btn-primary"
        >
          Start
          <ArrowRight className="w-5 h-5 ml-2" />
        </button>
      </div>
    </div>
  );
};

export default RequestSummary;
